$(document).ready(function(){

  // __________ Custom Bundle
  if($('#product-bundle-steps').length > 0){
    $('#product-bundle-steps .product-bundle-step').click(function (e) {
      e.preventDefault();
      $(this).addClass('active');
      $(this).siblings('.product-bundle-step').removeClass('active');
      var data_tab = $(this).data('bundle-tab-target');
      $('.product-bundle-products .product-bundle-products-row[data-bundle-tab="'+data_tab+'"]').removeClass('hidden').siblings('.product-bundle-products-row').addClass('hidden');
      $("#bundle-searchbar").val("").trigger("keyup");
    });

    function change_bundle_steps(current_step, complete){
      if (complete == true) {
        $('#product-bundle-steps .product-bundle-step[data-bundle-tab-target="'+current_step+'"]').addClass('success').next('.product-bundle-step').click();
      }else{
        $('#product-bundle-steps .product-bundle-step[data-bundle-tab-target="'+current_step+'"]').removeClass('success');
      }
      if($('#product-bundle-steps .product-bundle-step').length == $('#product-bundle-steps .product-bundle-step.success').length){
        $('.product-bundle-atc .product-form__buttons').removeClass('hidden');
        $(".product-bundle-products").find(".product-bundle-checkbox input:checked").each(function(i,j) {
          i = i+1;
          $(this).attr("name", "properties[ITEM" + i + "]");
        });
      }else{
        $('.product-bundle-atc .product-form__buttons').addClass('hidden');
      }
    }
    change_bundle_steps(0, false)
    
    $('.product-bundle-products .product-bundle-card .product-bundle-checkbox input[type="checkbox"]').on('change',function () {
      var product_limit = $(this).parents('.product-bundle-products-row').data('bundle-product');
      var checked_values = $(this).parents('.product-bundle-products-row').find('.product-bundle-checkbox input[type="checkbox"]:checked').length;
      var tab = $(this).parents('.product-bundle-products-row').data('bundle-tab');
      if(product_limit == checked_values){
        $(this).parents('.product-bundle-item').siblings('.product-bundle-item').find('.product-bundle-checkbox input[type="checkbox"]:not(:checked)').attr('disabled','disabled');
        change_bundle_steps(tab, true);
      }else{
        $(this).parents('.product-bundle-item').siblings('.product-bundle-item').find('.product-bundle-checkbox input[type="checkbox"]:not(:checked)').removeAttr('disabled');
        change_bundle_steps(tab, false);
      }
    });

    $("#bundle-searchbar").on("keyup", function() {
      var value = $(this).val().toLowerCase();
      $(".product-bundle-products-row:not(.hidden) .product-bundle-item").filter(function() {
        $(this).toggle($(this).find(".product-bundle-card-title .card_title").text().toLowerCase().indexOf(value) > -1)
      })
    });
    
    $("#bundle-search-clear").click(function(e) {
      $("#bundle-searchbar").val("").trigger("keyup");
    });

    // Bundle Quick View
    $('.product-bundle-quick-view-btn').on('click', function(e) {
      e.preventDefault();
      $('#product-bundle-quick-view').fadeIn();
      $('body').addClass('overflow-hidden');
      let producturl = `/products/${$(this).data('product-handle')}?view=product-bundle-quick-view`;
      fetch(producturl)
      .then(responseText => responseText.text())
      .then((responseText)=>{
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        console.log(html)
        $('#product-bundle-quick-view .product-bundle-quick-view-block').html($(html).find('.product-bundle-quick-view-block').html());
        var product_video_showcase_model = new Swiper("#product-bundle-img-slider", {
          slidesPerView: 1,
          spaceBetween: 10,
          loop: true,
          pagination: {
            el: "#product-bundle-img-slider .swiper-pagination", 
            clickable: true,
          },
        });
      });
    });
    
    $('#product-bundle-quick-view-close').on('click', function(e) {
      e.preventDefault();
      $('#product-bundle-quick-view').fadeOut();
      $('body').removeClass('overflow-hidden');
      $('#product-bundle-quick-view .product-bundle-quick-view-block').empty();
    });
    
  }
  

  
  // __________ Custom Bundle
  
});


document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".product-bundle-checkbox input[type='checkbox']").forEach(function (checkbox) {
        checkbox.addEventListener("change", function () {
            let productId = this.id; 
            let productTitle = this.value; 
            let innerBundle = document.querySelector(".inner-bundle"); 

            // Product image fetch karva mate
            let productImage = this.dataset.image || "https://via.placeholder.com/100"; // Default image if not found

            if (this.checked) {
                let productDiv = document.createElement("div");
                productDiv.classList.add("bundle-product");
                productDiv.setAttribute("data-product-id", productId);
                productDiv.innerHTML = `
                    <img src="${productImage}" alt="${productTitle}" style="width:60px; height:60px;">
                `;

                innerBundle.appendChild(productDiv);
            } else {
                let existingProduct = document.querySelector(`.inner-bundle .bundle-product[data-product-id='${productId}']`);
                if (existingProduct) {
                    existingProduct.remove();
                }
            }
        });
    });
});


const productBundleInfo = document.querySelector(".product-bundle-info");
const navbarContainer = document.querySelector(".navbar-container");

// Mutation Observer to check when content is added or removed
const observer = new MutationObserver(() => {
    if (productBundleInfo.innerHTML.trim() !== "") {
        navbarContainer.classList.add("new-class"); // Replace 'new-class' with your desired class
    } else {
        navbarContainer.classList.remove("new-class"); // Remove class when div is empty
    }
});

// Observe changes in the productBundleInfo div
observer.observe(productBundleInfo, { childList: true, subtree: true });


document.querySelectorAll(".product-bundle-btn").forEach((btn) => {
    btn.addEventListener("click", function() {
        this.classList.toggle("new-inner-class"); // Class add & remove automatically
    });
});



$(document).ready(function () {
    $(".product-bundle-step").on("classChange", function () {
        if ($(this).hasClass("success")) {
            $("html, body").animate({
                scrollTop: $("#product-bundle-steps").offset().top
            }, 500); // 500ms scroll speed
        }
    });

    // Class change detection
    let observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === "class") {
                $(mutation.target).trigger("classChange");
            }
        });
    });

    $(".product-bundle-step").each(function () {
        observer.observe(this, { attributes: true });
    });
});


      